import MedicineList from "../../MedicineList/MedicineList"


const Drugs = () => {
  return (
    <div>
      <MedicineList/>
    </div>
  )
}

export default Drugs
